import React from 'react'
import { Users, Gamepad2, RotateCcw, ThumbsUp } from 'lucide-react'

export function LiveSquadFeed({ onDuelChallenge }) {
  const squad = [
    {
      id: 1,
      name: 'Mateo G.',
      avatar: 'M',
      color: 'from-purple-600 to-indigo-600',
      badge: '🔥 12 días',
      activity: 'En Duelo Neuro-Math Blitz',
      icon: Gamepad2,
      action: 'duel',
    },
    {
      id: 2,
      name: 'Sofia V.',
      avatar: 'S',
      color: 'from-cyan-600 to-blue-600',
      badge: '🏆 Récord',
      activity: 'Superó tu récord en Fake News (+95 BP)',
      icon: RotateCcw,
      action: 'rematch',
    },
    {
      id: 3,
      name: 'Lucas M.',
      avatar: 'L',
      color: 'from-slate-700 to-slate-800',
      badge: '● En vivo',
      activity: 'Completó reto Pensamiento Crítico',
      icon: ThumbsUp,
      action: 'cheer',
    },
  ]

  return (
    <div className="rounded-2xl bg-gradient-to-b from-[#121824] to-[#0c121c] border border-slate-800 p-4 shadow-xl space-y-3">
      {/* Header */}
      <div className="flex items-center justify-between text-xs">
        <div className="flex items-center gap-1.5 font-extrabold text-white">
          <Users size={16} className="text-cyan-400" />
          <span>Escuadrón en Vivo</span>
        </div>
        <span className="px-2 py-0.5 rounded-full bg-emerald-950/80 border border-emerald-500/40 text-emerald-300 text-[10px] font-bold">
          3 Entrenando
        </span>
      </div>

      {/* List */}
      <div className="space-y-2">
        {squad.map((member) => {
          const ActionIcon = member.icon
          return (
            <div
              key={member.id}
              className="p-2.5 rounded-xl bg-slate-900/60 border border-slate-800/80 flex items-center justify-between gap-3"
            >
              <div className="flex items-center gap-2.5 min-w-0">
                <div
                  className={`w-8 h-8 rounded-full bg-gradient-to-tr ${member.color} flex items-center justify-center font-bold text-white text-xs shrink-0 shadow-md`}
                >
                  {member.avatar}
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-1.5">
                    <span className="text-xs font-bold text-white truncate">
                      {member.name}
                    </span>
                    <span className="text-[10px] text-cyan-400 font-semibold shrink-0">
                      {member.badge}
                    </span>
                  </div>
                  <div className="text-[10px] text-slate-400 truncate mt-0.5">
                    {member.activity}
                  </div>
                </div>
              </div>

              <button
                type="button"
                onClick={() => onDuelChallenge?.(member)}
                className="w-7 h-7 rounded-lg bg-slate-800 hover:bg-slate-700 active:scale-95 flex items-center justify-center text-slate-300 hover:text-white transition-all shrink-0 cursor-pointer"
                aria-label="Acción de escuadrón"
              >
                <ActionIcon size={14} />
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}
